import { STATUS_TYPE } from '../../../enum';

export interface GetBundleCategory {
  id: string;
}

export interface FindBundleCategory {
  search?: string;
  activeState?: boolean;
  limit?: number;
  skip?: number;
}

export interface CreatePatchBundleCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  emoji?: string | null;
  position: string | number;
  activeState: boolean;
  showOnHomePage: boolean;
}

export interface BundleCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  emoji?: string | null;
  position: string | number;
  activeState: boolean;
  showOnHomePage: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: BundleCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
